import styled from '@emotion/styled';
import { css } from "@emotion/react";

export const PromoBox = styled.div`
    padding: 15px;
    background: #fff;
    color: #E37751;
    border: 4px solid #E37751;
    font-weight: 700;
    text-align: center;

    i.fas {
        font-size: 24px;
        padding-right: 10px;
    }
`

export const PlanCardWrapper = styled.div`
    display: flex;
    justify-content: center;

    @media (min-width: 768px) {
        padding: 0 3px 0 3px !important;
    }
    
    @media screen and (min-height: 768px) {
        height: initial;
    }

    min-height: 642px;
`

export const PlanCard = styled.div`
    width: 98%;
    // height: 99%;
    border: ${props => props.isSelected ? '1px' : '0px'};
    border-color: ${props => props.isSelected ? '#37647D' : 'no'};
    border-style: ${props => props.isSelected ? 'solid' : 'none'};
    border-radius: ${props => props.theme.borderRadius};
    // elevation: 4;
    // box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    // padding-left: 0 !important;
    // padding-right: 0 !important;
    background: #fff;
    border: 1px solid rgba(0, 0, 0, 0.125);
    position: relative;
`

export const ColumnContent = styled.div`
    min-height: 549px;
    flex: 1;
    @media (max-width: 991px) {
        min-height: 600px;
    }
    @media (max-width: 425px) {
        min-height: 549px;
  }
`

export const PlanHeader = styled.div`
    padding: ${props => props.theme.spacing.single};
    padding-top: ${props => props.theme.spacing.double};
    // margin: 4px; // to compensate for elevation: 4 spacing
    border-top-left-radius: ${props => props.theme.borderRadius};
    border-top-right-radius: ${props => props.theme.borderRadius};
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background: ${props => props.backgroundImage
        ? props.backgroundImage
        : props.isSelected ? '#37647D'
            : 'linear-gradient(241.83deg, #84B86D -28.39%, #004E47 65.05%, #1E2F5C 123.45%), linear-gradient(228.75deg, #0F5F4B -28.71%, #09152F 142.5%)'};
    background-size: cover;
    background-position: center center;
    position: relative;
`

export const PlanHeaderImage = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    border-radius: ${props => props.theme.borderRadius} ${props => props.theme.borderRadius} 0 0;
    background-image: url(${props => props.source.uri});
    background-size: cover;
`

export const PlanTitlePrefix = styled.div`
    ${props => css`${props.theme.textStyles.regular}`}
    color: #fff;

    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 17px;
    text-align: center;
    letter-spacing: 0.1em;
    text-transform: uppercase;
`

export const PlanTitle = styled.div`
    ${props => css`${props.theme.textStyles.large}`}
    color: #fff;
    text-align: center;
`

export const PlanInnerContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-transform: uppercase;
    margin-top: ${props => props.theme.spacing.threeQuarter};
    margin-bottom: ${props => props.theme.spacing.half};
    
    @media (min-width: 768px) and (max-width: 1199.98px) {
        flex-direction: column;
        align-items: center;
    }
    z-index: 55;
`

export const PlanPrice = styled.div`
    ${props => css`${props.theme.textStyles.title3}`}
    color: ${props => props.theme.colorStyles.BrandPrimary};

    @media (min-width: 768px) and (max-width: 1199.98px) {
        font-size: 26px;
    }
`

export const PlanPriceSeparator = styled.div`
    ${props => css`${props.theme.textStyles.title3}`}
    color: ${props => props.theme.colorStyles.BrandPrimary};
    padding-left: 5px;

    // @media (min-width: 768px) and (max-width: 1199.98px) {
    //    display:none;
    // }
`

export const PlanPricePostfix = styled.div`
    ${props => css`${props.theme.textStyles.miniCap}`}
    color: #000;
    padding-bottom: 3px;
    text-transform: initial;
`

export const PlanUpcomingLabel = styled.div`
    ${props => css`${props.theme.textStyles.miniCap}`}
    color: #629EBF;
    text-align: center;
    padding-bottom: 3px;
    padding-top: 16px;
    padding-bottom: 16px;
    padding-left: ${props => props.theme.spacing.single};
    padding-right: ${props => props.theme.spacing.single};
    margin-bottom: 16px;
    text-align: center;
`

export const PlanCurrentLabel = styled.div`
    ${props => css`${props.theme.textStyles.miniCap}`}
    color: #629EBF;
    text-align: center;
    
    padding-bottom: 3px;
    padding-top: 16px;
    padding-bottom: 16px;
    padding-left: ${props => props.theme.spacing.single};
    padding-right: ${props => props.theme.spacing.single};
    margin-bottom: 16px;
    margin-left: auto;
    margin-right: auto;
`

export const PlanCurrentLabelCustom = styled.div`
    ${props => css`${props.theme.textStyles.miniCap}`}
    color: #000;
    text-align: center;
    
    padding-top: 16px;
    padding-bottom: 16px;
    padding-left: ${props => props.theme.spacing.single};
    padding-right: ${props => props.theme.spacing.single};
    font-size: 13px;
    font-weight: initial;
`

export const PlanButtonLink = styled.a`
    display: block;
    // margin-left: auto;
    // margin-right: auto;
    margin-top: ${props => props.theme.spacing.single};
    margin-bottom: ${props => props.theme.spacing.single};
    border-radius: ${props => props.theme.borderRadius};
    border-width: 0px;
    background-color: transparent;
    padding-left: ${props => props.theme.spacing.half};
    padding-right: ${props => props.theme.spacing.half};
    flex-direction: row;
    align-items: center;
    justify-content: space-around;
    width: 100%;
    // box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);

    @media (min-width: 768px) and (max-width: 991.98px) {
        // width: 90%;
    }

    ${props => props.fullWidth ?
        `
        margin-left: 0;
        margin-right: 0;
        margin-bottom: 0;
        margin-top: 0;
        width: 100%;
    `
        : ``}

    
`

export const PlanButton = styled.a`
    display: block;
    // margin-left: auto;
    // margin-right: auto;
    margin-top: ${props => props.theme.spacing.single};
    margin-bottom: ${props => props.theme.spacing.single};
    border-radius: ${props => props.theme.borderRadius};
    border-width: 0px;
    background-color: ${props => props.disabled
        ? `gray`
        : props => props.backgroundColor ? props.backgroundColor : props.theme.colorStyles.BrandPrimary
    };
    padding-left: ${props => props.theme.spacing.half};
    padding-right: ${props => props.theme.spacing.half};
    flex-direction: row;
    align-items: center;
    justify-content: space-around;
    width: 100%;
    // box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);

    @media (min-width: 768px) and (max-width: 991.98px) {
        // width: 90%;
    }

    ${props => props.fullWidth ?
        `
        margin-left: 0;
        margin-right: 0;
        margin-bottom: 0;
        margin-top: 0;
        width: 100%;
    `
        : ``}

    &:hover {
        text-decoration: none;
        background-color: ${props => props.disabled ? `gray` : `#37647D`};
    }
`

export const PlanButtonText = styled.div`
    ${props => css`${props.theme.textStyles.miniBold}`}
    padding-top: ${props => props.theme.spacing.threeQuarter};
    padding-bottom: ${props => props.theme.spacing.threeQuarter};
    padding-left: ${props => props.theme.spacing.single};
    padding-right: ${props => props.theme.spacing.single};
    text-align: center;
    color: ${props => props.color ? props.color[props.theme.colorStyles.UserInterfaceStyle] : '#fff'};
    text-transform: uppercase;
    letter-spacing: 0.5px;
`

export const PlanTabsRow = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: stretch;
    margin-left: ${props => props.theme.spacing.single};
    margin-right: ${props => props.theme.spacing.single};
    margin-top: ${props => props.theme.spacing.half};
    margin-bottom: ${props => props.theme.spacing.single};
`

export const PlanTab = styled.div`
    flex: 1;
    background-color: ${props => props.isActive ? props.theme.colorStyles.BrandPrimary : props.theme.colorStyles.Background};
    border-top-width: 1px;
    border-bottom-width: 1px;
    border-right-width: ${props => props.isFirst ? '0px' : '1px'};
    border-left-width: ${props => props.isLast ? '0px' : '1px'};
    border-color: ${props => props.theme.colorStyles.BrandPrimary};
    border-top-left-radius: ${props => props.isFirst ? props.theme.borderRadius : '0px'};
    border-bottom-left-radius: ${props => props.isFirst ? props.theme.borderRadius : '0px'};
    border-top-right-radius: ${props => props.isLast ? props.theme.borderRadius : '0px'};
    border-bottom-right-radius: ${props => props.isLast ? props.theme.borderRadius : '0px'};
    border-style: solid;
`

export const PlanTabText = styled.div`
    ${props => css`${props.theme.textStyles.miniBold}`}
    padding: ${props => props.theme.spacing.half};
    text-align: center;
    color: ${props => props.isActive ? '#fff' : props.theme.colorStyles.BrandPrimary};
    text-transform: uppercase;
    letter-spacing: 0.5px;
`

export const PlanRibbon = styled.div`
    
    border-radius: 7px;
    border-width: 0px;
    background-color: ${props => props.backgroundColor ? props.backgroundColor : '#3FC28F'};
    padding-left: ${props => props.theme.spacing.half};
    padding-right: ${props => props.theme.spacing.half};
    flex-direction: row;
    align-items: center;
    justify-content: space-around;
    position: absolute;
    top: -14px;
    right: 8px;
`

export const PlanRibbonText = styled.div`
    ${props => css`${props.theme.textStyles.miniBold}`}
    padding-top: ${props => props.theme.spacing.third};
    padding-bottom: ${props => props.theme.spacing.third};
    padding-left: 5px;
    padding-right: 5px;
    text-align: center;
    color: ${props => props.color ? props.color : '#000'};
    
    font-style: normal;
    font-weight: 700;
    font-size: 12px;
    line-height: 14px;
    letter-spacing: 0.1em;
    text-transform: uppercase;
`

export const PlanPromoRibbon = styled.div`
    // border-bottom-left-radius: ${props => props.theme.borderRadius};
    // border-top-right-radius: ${props => props.theme.borderRadius};
    // border-width: 0px;
    background-color: ${props => props.backgroundColor ? props.backgroundColor : '#3FC28F'};
    // padding-left: ${props => props.theme.spacing.half};
    // padding-right: ${props => props.theme.spacing.half};
    flex-direction: row;
    align-items: center;
    justify-content: space-around;
    // position: absolute;
    // top: 0;
    // right: 0;
    z-index:55;
`

export const PlanPromoRibbonText = styled.div`
    ${props => css`${props.theme.textStyles.miniBold}`}
    padding-top: ${props => props.theme.spacing.third};
    padding-bottom: ${props => props.theme.spacing.third};
    padding-left: ${props => props.theme.spacing.single};
    padding-right: ${props => props.theme.spacing.single};
    text-align: center;
    color: ${props => props.color ? props.color : '#000'};
    text-transform: uppercase;
    letter-spacing: 0.5px;
`

export const PlanPromoText = styled.div`
    ${props => css`${props.theme.textStyles.large}`}
    color: ${props => props.color ? props.color : '#000'};
    margin-top: ${props => props.theme.spacing.single};
    text-align: center;

    @media (min-width: 768px) and (max-width: 991.98px) {
        font-size: 14px;
    }

    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 17px;
    text-transform: initial;
`

export const PlanBody = styled.div`
    padding: ${props => props.theme.spacing.single};
    border-bottom-left-radius: ${props => props.theme.borderRadius};
    border-bottom-right-radius: ${props => props.theme.borderRadius};
    margin: 0;
    background: #fff;
    
    height: 81%;
    display: flex;
    flex-direction: column;
    position: relative;
`

export const PlanBodyCtaContainer = styled.div`
    margin-top: auto;
    position: absolute;
    bottom: 0;
    // width: 93%;
    left:15;
    right:15;
`

export const PlanBodyText = styled.div`
    ${props => props.isLink ? css`${props.theme.textStyles.regularBold}` : css`${props.theme.textStyles.bodyRegular}`}
    color: ${props => props.isLink ? props.theme.colorStyles.BrandPrimary : props.theme.colorStyles.LabelPrimary};
    width: 100%;
    margin-bottom: ${props => props.marginBottom ? props.theme.spacing.single : 0};

    ul {
        padding-left: 0px;
        position: relative;
    }
    li {
        list-style: none;
        padding-left: ${props => props.theme.spacing.double};
        padding-bottom: ${props => props.theme.spacing.half};
        position: relative;
        margin-bottom:17px;

        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        line-height: 17px;
    }

    li::before {
        content: '';
        display: block;
        height: 22px;
        width: 22px;
        position: absolute;
        left: 0;
        background-position: center;
        background-repeat: no-repeat;
        background-image: url("data:image/svg+xml,%3Csvg width='19' height='19' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12Z' fill='%230EA39A'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M17.3107 8.04297C17.7012 8.43349 17.7012 9.06666 17.3107 9.45718L11.1036 15.9572C10.7131 16.3477 10.0799 16.3477 9.68938 15.9572L6.68938 12.9572C6.29885 12.5667 6.29885 11.9335 6.68938 11.543C7.0799 11.1524 7.71307 11.1524 8.10359 11.543L10.3965 13.8359L15.8965 8.04297C16.287 7.65244 16.9202 7.65244 17.3107 8.04297Z' fill='white'/%3E%3C/svg%3E");
        
        
        margin-top: -2px;
    }

    li::after{
        position: absolute;
        left:8;
        content: "";
        display: block;
        margin-top: 13px;
        width: 95%;
        border-bottom: solid 1px rgba(73, 73, 73, 0.11);
    }
    a {
        font-weight: 700;
        color: #629EBF;
        text-decoration-style: dotted;
        text-decoration: underline;
        cursor: help;
    }

    code {
        padding: 4px 4px;
        background: #FFAE4F;
        border-radius: 4px;
        font-family: inherit;
        font-weight: 700;
        color: white;
        line-height: 12px;
        display: inline-block;
        -webkit-text-stroke: 0;
    }
`

export const PlanBodyBulletItem = styled.div`
    flex-direction: row;
    align-items: flex-start;
    padding-right: ${props => props.theme.spacing.triple};
    padding-bottom: ${props => props.theme.spacing.half};
`

export const PlanBodyBulletIcon = styled.div`
    padding-top: 4px;
    margin-right: ${props => props.theme.spacing.half};
    color: ${props => props.theme.colorStyles.BrandPrimary};
`

export const PlanGeneralFeatures = styled.div`
    margin-bottom: ${props => props.theme.spacing.double};
    padding-left: ${props => props.theme.spacing.single};
    padding-right: ${props => props.theme.spacing.single};
`

export const PlanFeaturesLink = styled.div`
    color: ${props => props.theme.colorStyles.BrandPrimary};
`

export const PlanCustomPrice = styled.div`
    ${props => css`${props.theme.textStyles.title2}`}
    color: ${props => props.theme.colorStyles.LabelPrimary};
`

export const PlanCustomPriceSeparator = styled.div`
    ${props => css`${props.theme.textStyles.title3}`}
    color: ${props => props.theme.colorStyles.LabelPrimary};
`

export const PlanCustomPricePostfix = styled.div`
    ${props => css`${props.theme.textStyles.miniCap}`}
    color: ${props => props.theme.colorStyles.LabelPrimary};
    padding-bottom: 3px;
`

export const PlanCustomPricePrefix = styled.div`
    ${props => css`${props.theme.textStyles.miniCap}`}
    color: ${props => props.theme.colorStyles.LabelPrimary};
    align-self: center;
    margin-bottom: 6px;
`

export const PlanCustomPriceContainer = styled.div`
    margin-top: 12px;
`

export const PlanCustomSliderContainer = styled.div`
    margin-bottom: 24px;
`

export const PlanCustomSliderHint = styled.div`
    ${props => css`${props.theme.textStyles.tinyCap}`}
    color: ${props => props.theme.colorStyles.LabelSubdiv};
    text-align: center;
`

export const ThankYouVideoContainer = styled.div`
    width: 100%;
    height: ${props => props.height ? props.height : '300px'};
`

export const ThankYouVideoImage = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
`
export const ThankYouBody = styled.div`
    padding: ${props => props.theme.spacing.single};
`

export const ThankYouHeader = styled.div`
    ${props => css`${props.theme.textStyles.title2}`}
    color: ${props => props.color ? props.color : props.theme.colorStyles.LabelPrimary};
    margin-bottom: ${props => props.theme.spacing.single};
`

export const ThankYouText = styled.div`
    ${props => css`${props.theme.textStyles.large}`}
    color: ${props => props.color ? props.color : props.theme.colorStyles.LabelPrimary};
    margin-bottom: ${props => props.theme.spacing.double};
`

export const ThankYouDiscoverWrapper = styled.div`
    paddingTop: ${props => props.theme.spacing.single};
`

export const ThankYouDiscoverText = styled.div`
    ${props => css`${props.theme.textStyles.miniBody}`}
    color: ${props => props.color ? props.color : props.theme.colorStyles.LabelPrimary};
    margin-bottom: ${props => props.theme.spacing.half};
`

export const ThankYouDiscoverButton = styled.div`
    margin-top: ${props => props.theme.spacing.quarter};
    margin-bottom: ${props => props.theme.spacing.single};
    border-radius: ${props => props.theme.borderRadius};
    border-width: 0px;
    background-color: ${props => props.backgroundColor ? props.backgroundColor[props.theme.colorStyles.UserInterfaceStyle] : props.theme.colorStyles.BrandPrimary};
    padding-left: ${props => props.theme.spacing.half};
    padding-right: ${props => props.theme.spacing.half};
    flex-direction: row;
    align-items: center;
    justify-content: space-around;
    width: 100%;
`

export const Container = styled.div`
    padding: ${props => props.theme.spacing.single};
    background: ${props => props.gradient ?
        'linear-gradient(241.83deg, #84B86D -28.39%, #004E47 65.05%, #1E2F5C 123.45%), linear-gradient(228.75deg, #0F5F4B -28.71%, #09152F 142.5%)'
        : 'transparent'};
    color: ${props => props.color ? props.color : props.gradient ? '#fff' : props.theme.colorStyles.LabelPrimary};
    max-width: 544px;
    margin: 0 auto;
    ${props => props.noPaddingBottom ?
        `padding-bottom: 0px`
        : ''}
`


export const Heading = styled.div`
    ${props => css`${props.theme.textStyles.title3}`}
    margin-bottom: ${props => props.theme.spacing.single};
`

export const BodyRegular = styled.div`
    ${props => css`${props.theme.textStyles.bodyRegular}`}
    margin-bottom: ${props => props.theme.spacing.single};
`
export const BodyMini = styled.div`
    ${props => css`${props.theme.textStyles.miniBody}`}
    margin-bottom: ${props => props.marginBottom ? props.theme.spacing.double : '0'};
`

export const Link = styled.a`
    color: ${props => props.color ? props.color : props.theme.colorStyles.BrandPrimary};
`

export const PartnerButtonsWrapper = styled.div`
    display: flex;
    flex-wrap: wrap;
    margin-left: -${props => props.theme.spacing.single};
`

export const PartnerButton = styled.a`
    background-color: ${props => props.color ? props.color : props.theme.colorStyles.PartnerPrimary};
    padding: ${props => props.theme.spacing.single};
    flex: 1 1 25%;
    border-radius: ${props => props.theme.borderRadius};
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    margin-left: ${props => props.theme.spacing.single};
    margin-bottom: ${props => props.theme.spacing.single};
    position: relative;
`

export const PartnerButtonText = styled.div`
    ${props => css`${props.theme.textStyles.regularBold}`}
    color: ${props => props.color ? props.color : '#fff'};
`

export const PartnerButtonIcon = styled.span`
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='%23fff' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-chevron-right'%3E%3Cpolyline points='9 18 15 12 9 6'%3E%3C/polyline%3E%3C/svg%3E");
    display: block;
    width: 24px;
    height: 24px;
    position: absolute;
    right: ${props => props.theme.spacing.half};
    top: 50%;
    transform: translate(0,-50%);
`

export const PartnerCardsWrapper = styled.div`
    margin-left: -${props => props.theme.spacing.single};
    margin-right: -${props => props.theme.spacing.single};
    margin-top: ${props => props.theme.spacing.single};
    display: flex;
    flex-wrap: nowrap;
    overflow-x: auto;
    scroll-behavior: smooth;
    -webkit-overflow-scrolling: touch;

    &::-webkit-scrollbar {
        display: none;
    }
`

export const PartnerCard = styled.div`
    background-color: ${props => props.color ? props.color : props.theme.colorStyles.PartnerSecondary};
    margin-left: ${props => props.theme.spacing.single};
    margin-bottom: ${props => props.theme.spacing.single};
    border-radius: ${props => props.theme.borderRadius};
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    flex: 0 0 auto;
    min-height: 96px;
    width: 80%;
    color: #fff;

    &:last-child {
        margin-right: ${props => props.theme.spacing.single};
    }
`

export const PartnerCardImage = styled.div`
    width: 80px;
    height: 100%;
    background-image: url(${props => props.image});
    background-size: cover;
    background-position: center center;
    background-color: #ccc;
    float: left;
    border-top-left-radius: ${props => props.theme.borderRadius};
    border-bottom-left-radius:  ${props => props.theme.borderRadius};
`

export const PartnerCardHeading = styled.div`
    ${props => css`${props.theme.textStyles.regularBold}`}
    margin-bottom: ${props => props.theme.spacing.half};
    padding-left: 96px;
    padding-top: ${props => props.theme.spacing.single};
    padding-right: ${props => props.theme.spacing.single};
`

export const PartnerCardText = styled.div`
    ${props => css`${props.theme.textStyles.miniRegular}`}
    padding-left: 96px;
    padding-bottom: ${props => props.theme.spacing.single};
    padding-right: ${props => props.theme.spacing.single};
`

export const PartnerStatsWrapper = styled.div`
    display: flex;
    flex-wrap: wrap;
    margin-top: ${props => props.theme.spacing.single};
    margin-bottom: ${props => props.theme.spacing.single};
`

export const PartnerStatsItem = styled.div`
    padding: ${props => props.theme.spacing.single};
    flex: 1 1 30%;
    position: relative;

    &:first-of-type {
        border-right: 1px solid rgba(255,255,255,.5);
        // border-bottom: 1px solid rgba(255,255,255,.5);
    }


    &:last-child {
        // border-top: 1px solid rgba(255,255,255,.5);
        // border-left: 1px solid rgba(255,255,255,.5);
        // margin-top: -1px;
    }
`

export const PartnerStatsImg = styled.img`
    width: 36px;
    height: 36px;
    display: inline-block;
    vertical-align: middle;
    border: 0;
    padding-right: ${props => props.theme.spacing.third};
    padding-bottom: ${props => props.theme.spacing.quarter};
`

export const PartnerStatsNumber = styled.div`
    ${props => css`${props.theme.textStyles.large}`}
    display: inline-block;
    vertical-align: middle;
    padding-bottom: 4px;
`

export const VideoWrapper = styled.div`
    position: relative;
    padding-bottom: 56.25%;
    height: 0;

    iframe {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
    }
`

export const PopupIcon = styled.div`
    width: 211px;
    height: 141px; 
    background: url('/assets/images/gp_popup_icon.png');
    background: url('/assets/images/gp_popup_icon.svg'),linear-gradient(transparent, transparent);
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center center;
    margin: 0 auto;
`

export const PopupImageHeader = styled.div`
    background: url('https://jpcom.imgix.net/cms/partner/gp-pastor-20211118081414.jpg?w=750');
    width: 100%;
    height: 0;
    padding-bottom: 56.75%;
    background-size: cover;
    background-position: center center;
    background-repeat: no-repeat;
`

export const PopupBody = styled.div`
    @media (min-width: 768px) {
        padding: 30px;
    }
`

export const PopupFooter = styled.div`
    position: sticky;
    bottom: 0px;
    background-color: #fff;
    box-shadow: 0 0 20px 0 rgba(0,0,0,0.15);
    z-index: 1055;
    color: #E37751;
    flex-direction: column;

    @media (min-width: 768px) {
        padding: 30px;
    }

    @media (max-width: 575.98px){
        font-size: 13px;
    }
`



export const NewPlanHeader = styled.div`
    padding: ${props => props.theme.spacing.single};
    
    // margin: 4px; // to compensate for elevation: 4 spacing
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    // background-color: #739574;
    
    
    background-size: cover;
    background-position: center center;
    position: relative;
`
